import { sniff } from '@/util'

// 关闭所有Webview
const closeAllWebview = function () {
  if (sniff.isUboxAndroidApp) {
    window.app?.closeAllWebview && window.app?.closeAllWebview()
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.closeAllWebview && window?.webkit?.messageHandlers?.closeAllWebview.postMessage('')
  }
}

export default closeAllWebview